import { render, staticRenderFns } from "./BreadcrumbCpn.vue?vue&type=template&id=fdea0076&scoped=true"
import script from "./BreadcrumbCpn.vue?vue&type=script&lang=js"
export * from "./BreadcrumbCpn.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbCpn.vue?vue&type=style&index=0&id=fdea0076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea0076",
  null
  
)

export default component.exports